module.exports = __webpack_public_path__ + "static/media/1016140.21728c2c.png";